import { Injectable } from '@angular/core';

import {
    CheckPersonRulesMatrixRequest,
    CheckPersonsRulesMatrixRequest,
    CourtForAddBookingTimeSlotsModel,
    CreateCourtBookingPlayerModel,
    CreateCourtBookingRequest
} from '@bayclubs/court-booking-employee-api';

import { CourtBookingSaveFormModel } from '../models/court-booking-save-form.model';

@Injectable({
    providedIn: 'root'
})
export class CourtBookingSaveMapperService {
    constructor() {}

    public createAddCourtBookingRequest(
        form: CourtBookingSaveFormModel,
        timeRange: CourtForAddBookingTimeSlotsModel
    ): CreateCourtBookingRequest {
        const request = {
            date: form.date,
            firstPlayerId: form.firstPlayer.personId,
            timeFromInMinutes: form.timeFromInMinutes,
            categoryOptionsId: form.categoryOptionsId,
            secondPlayer: form.secondPlayer
                ? ({
                      personId: form.secondPlayer.personId,
                      invitationText: form.secondPlayer.personId ? null : form.secondPlayer.eMail
                  } as CreateCourtBookingPlayerModel)
                : null,
            thirdPlayer: form.thirdPlayer
                ? ({
                      personId: form.thirdPlayer.personId,
                      invitationText: form.thirdPlayer.personId ? null : form.thirdPlayer.eMail
                  } as CreateCourtBookingPlayerModel)
                : null,
            fourthPlayer: form.fourthPlayer
                ? ({
                      personId: form.fourthPlayer.personId,
                      invitationText: form.fourthPlayer.personId ? null : form.fourthPlayer.eMail
                  } as CreateCourtBookingPlayerModel)
                : null,
            courtId: form.courtId,
            timeToInMinutes: form.timeFromInMinutes + timeRange.durationInMinutes
        } as CreateCourtBookingRequest;
        return request;
    }

    public createCheckPersonsRulesMatrixRequest(
        form: CourtBookingSaveFormModel,
        clubId: string,
        categoryCode: string,
        duration?: number | null
    ): CheckPersonsRulesMatrixRequest {
        const request = { clubId, date: form.date, categoryCode, duration } as CheckPersonsRulesMatrixRequest;
        const players = [];
        players.push({
            personId: form.firstPlayer.personId,
            isMainPlayer: true
        } as CheckPersonRulesMatrixRequest);
        if (form.secondPlayer !== null && form.secondPlayer.personId !== null) {
            players.push({
                personId: form.secondPlayer.personId,
                isMainPlayer: false
            } as CheckPersonRulesMatrixRequest);
        }
        if (form.thirdPlayer !== null && form.thirdPlayer.personId !== null) {
            players.push({
                personId: form.thirdPlayer.personId,
                isMainPlayer: false
            } as CheckPersonRulesMatrixRequest);
        }
        if (form.fourthPlayer !== null && form.fourthPlayer.personId !== null) {
            players.push({
                personId: form.fourthPlayer.personId,
                isMainPlayer: false
            } as CheckPersonRulesMatrixRequest);
        }
        request.persons = players;
        return request;
    }
}
